import React from 'react'
import { useIntl } from 'react-intl'
import { ToolTipUI } from '../../../widgets/components/UI/ToolTipUI'
import StackedBarChart from './StackedBarChart'

interface RecordCountTimeProps {
  heading: string
  tooltip: string
  analyticStatData: any
  setFiles: any
  files: any
}

const RecordCountTime: React.FC<RecordCountTimeProps> = ({
  heading,
  tooltip,
  analyticStatData,
  setFiles,
  files,
}) => {
  const { formatMessage } = useIntl()
  const category = [
    { name: 'All Files', value: undefined },
    { name: 'audio', value: 'audio' },
    { name: 'excel', value: 'excel' },
    { name: 'others', value: 'others' },
    { name: 'pdf', value: 'pdf' },
    { name: 'ppt', value: 'ppt' },
    { name: 'text', value: 'text' },
    { name: 'videos', value: 'videos' },
    { name: 'word Doc', value: 'wordDoc' },
  ]

  return (
    <>
      <div className='bg-white rounded-2 p-4'>
        <div className='px-4 pb-0 d-flex flex-md-row flex-column justify-content-between'>
          <div className='d-flex align-items-center gap-1'>
            <h4 className='font-size-14 text-muted fw-normal mb-md-0 mb-2'>
              {formatMessage({ id: heading })}
            </h4>
            <ToolTipUI tooltipText={formatMessage({ id: tooltip })} />
          </div>
          <div className='dropdown-center'>
            <select
              className='form-select h-40px font-size-12 font-weight-500 bg-white cursor-pointer'
              onChange={(e) => setFiles(e.target.value)}
              value={files}
            >
              {category?.map((item: any) => {
                return <option value={item?.value}>{item?.name}</option>
              })}
            </select>
          </div>
        </div>
        <StackedBarChart recordCountData={analyticStatData?.recordCount} />
      </div>
    </>
  )
}

export default RecordCountTime
